import React from 'react';
import { useRecommendedGoods } from '../../queries/useRecommendedGoods';
import { RecommendGoodsCarouselItem } from './RecommendGoodsCarouselItem';

// 검색 보조 화면 "최근 본 검색 상품" 추천 캐로셀 섹션 (EXP1802 B군).
// useRecommendedGoods 가 실험/데이터 게이팅을 담당 → A군이거나 데이터 없으면 null.
// 상품 노출/클릭/찜 로깅은 RecommendGoodsCarouselItem 내부에서 처리.
export const RecommendGoods = () => {
  const { data } = useRecommendedGoods();

  if (!data || data.item_list.length === 0) {
    return null;
  }

  return (
    <RecommendGoodsCarouselItem
      carousel={{ title: data.title, item_list: data.item_list }}
      isLogEnabled={true}
    />
  );
};
